import { useTranslation } from 'react-i18next';

import { useSprintProgress } from '@/features/insights';
import { Mono } from '@/shared/ui/atoms/Mono';
import { ProgressBar } from '@/shared/ui/atoms/ProgressBar';
import './SprintBlock.styl';

export function SprintBlock() {
  const { sprint, isPending } = useSprintProgress();
  const { t } = useTranslation(undefined, { keyPrefix: 'shell.sprint' });
  if (isPending)
    return <div className="w-sprint w-sprint--empty">{t('loading')}</div>;
  if (!sprint)
    return <div className="w-sprint w-sprint--empty">{t('none')}</div>;
  const pct =
    sprint.totalTasks === 0
      ? 0
      : (sprint.completedTasks / sprint.totalTasks) * 100;
  return (
    <div className="w-sprint">
      <div className="w-sprint__head">
        <div className="w-sprint__name">{sprint.name}</div>
        <Mono className="w-sprint__left">
          {t('daysLeft', { count: sprint.daysLeft })}
        </Mono>
      </div>
      <ProgressBar
        value={pct}
        height={5}
        label={t('progress', { name: sprint.name })}
        className="w-sprint__bar"
      />
      <div className="w-sprint__meta">
        {t('tasksClosed', {
          done: sprint.completedTasks,
          total: sprint.totalTasks
        })}
      </div>
      <div className="w-sprint__meta">
        <Mono>{sprint.deliveredPoints}</Mono> /{' '}
        <Mono>{sprint.plannedPoints}</Mono> {t('pts')}
      </div>
    </div>
  );
}
